import { BaseEndpoint, BaseSDK } from '@livefree/js-sdk';

class LogoutEndpoint extends BaseEndpoint {
  constructor(config) {
    super('api/v1/logout', config);
  }

  logout(logoutId) {
    return super.create({ logoutId: logoutId });
  }

  info(logoutId) {
    const url = super.appendUrl('/info');
    return super.httpGET({ url, query: { logoutId } });
  }
}

export class LogoutClient extends BaseSDK {
  #logout_endpoint;
  constructor(baseUrl) {
    super(baseUrl);
    this.#logout_endpoint = new LogoutEndpoint(this.config);
  }

  logout(logoutId) {
    return this.#logout_endpoint.logout(logoutId);
  }

  info(logoutId) {
    return this.#logout_endpoint.info(logoutId);
  }
}
